<template>
    <div class="">
        <el-alert
            class="fin-mb-3"
            v-if="multipleSelectionError"
            :title="multipleSelectionError"
            type="error">
        </el-alert>

        <div class="fin-flex fin-justify-between fin-items-center fin-mb-2 fin-w-full">
            <h1 class="fin-text-2xl fin-font-bold fin-text-blue-800">Tickets</h1>
            <div>
                <el-button v-if="hasAdPermissions && !isTenant" type="primary"
                           @click.prevent="emailsVisible = true">
                    Email
                </el-button>
                <el-button v-if="hasAdPermissions && !isTenant" type="primary"
                           @click.prevent="supportCategoryVisible = true">
                    Support User Category Filter
                </el-button>
                <el-button v-if="hasAdPermissions && !isTenant" type="primary"
                           @click.prevent="exportTicketStatistics(tableData)">
                    Export Statistics
                    <i class="fa-solid fa-chart-simple fin-text-white-500"></i>
                </el-button>
                <el-button v-if="!isTenant" type="primary" @click.prevent="inboundTicketsVisible = true">
                    Inbound Tickets
                </el-button>
                <el-button type="success" @click.prevent="createVisible = true">
                    Create Ticket
                </el-button>
            </div>
        </div>

        <div v-if="(isTenant && hasPermissions) || !isTenant">
            <label class="fin-text-md fin-my-4 fin-font-bold fin-flex-none">All Ticket Totals</label>

            <div class="fin-mb-8 fin-grid fin-gap-4"
                 :class="isTenant ? 'fin-grid-cols-5' : 'fin-grid-cols-6'">
                <div
                    class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                    @click="getTickets(true)">
                    <div class="fin-rounded-full fin-p-2 fin-bg-blue-200">
                        <i class="fas fa-ticket-alt fa-lg fin-text-blue-500"></i>
                    </div>

                    <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                        <span>unsolved tickets</span>
                        <span>{{ allUnsolvedTotals }}</span>
                    </div>
                </div>
                <div
                    class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                    @click="getTickets(false, true)">
                    <div class="fin-rounded-full fin-p-2 fin-bg-blue-200">
                        <i class="fas fa-ticket-alt fa-lg fin-text-blue-500"></i>
                    </div>

                    <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                        <span>solved tickets</span>
                        <span>{{ allSolvedTotals }}</span>
                    </div>
                </div>
                <div
                    class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                    @click="getTickets(false, false, true)">
                    <div class="fin-rounded-full fin-p-2 fin-bg-blue-200">
                        <i class="fas fa-ticket-alt fa-lg fin-text-blue-500"></i>
                    </div>

                    <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                        <span>closed tickets</span>
                        <span>{{ allClosedTotals }}</span>
                    </div>
                </div>
                <div
                    class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                    @click="getTickets(false,false, false, true)">
                    <div class="fin-rounded-full fin-p-2 fin-bg-green-200">
                        <i class="fas fa-ticket-alt fa-lg fin-text-green-500"></i>
                    </div>

                    <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                        <span>Recently updated tickets</span>
                        <span>{{ allUpdatedTotals }}</span>
                    </div>
                </div>
                <div
                    class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                    @click="getTickets(false,false, false, false, true)">
                    <div class="fin-rounded-full fin-p-2 fin-bg-orange-200">
                        <i class="fas fa-ticket-alt fa-lg fin-text-orange-500"></i>
                    </div>
                    <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                        <span>Suspended tickets</span>
                        <span>{{ allSuspendedTotals }}</span>
                    </div>
                </div>
                <div
                    class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                    @click="getTickets(false,false, false, false, false, true)">
                    <div class="fin-rounded-full fin-p-2 fin-bg-red-200">
                        <i class="fas fa-ticket-alt fa-lg fin-text-red-500"></i>
                    </div>

                    <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                        <span>Deleted tickets</span>
                        <span>{{ allDeletedTotals }}</span>
                    </div>
                </div>
            </div>
        </div>

        <label class="fin-text-md fin-my-4 fin-font-bold">My Ticket Totals</label>

        <div class="fin-mb-8 fin-grid fin-gap-4"
             :class="isTenant ? 'fin-grid-cols-5' : 'fin-grid-cols-6'">
            <div
                class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                @click="getTickets(true,false, false, false, false, false, _.get(user, 'id', _.get(tenantAuthUser, 'id')), true)">
                <div class="fin-rounded-full fin-p-2 fin-bg-blue-200">
                    <i class="fas fa-ticket-alt fa-lg fin-text-blue-500"></i>
                </div>

                <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                    <span>My unsolved tickets</span>
                    <span>{{ myUnsolvedTotals }}</span>
                </div>
            </div>
            <div
                class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                @click="getTickets(false,true, false, false, false, false, _.get(user, 'id', _.get(tenantAuthUser, 'id')), true)">
                <div class="fin-rounded-full fin-p-2 fin-bg-blue-200">
                    <i class="fas fa-ticket-alt fa-lg fin-text-blue-500"></i>
                </div>

                <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                    <span>My solved tickets</span>
                    <span>{{ mySolvedTotals }}</span>
                </div>
            </div>
            <div
                class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                @click="getTickets(false,false, true, false, false, false, _.get(user, 'id', _.get(tenantAuthUser, 'id')), true)">
                <div class="fin-rounded-full fin-p-2 fin-bg-blue-200">
                    <i class="fas fa-ticket-alt fa-lg fin-text-blue-500"></i>
                </div>

                <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                    <span>My closed tickets</span>
                    <span>{{ myClosedTotals }}</span>
                </div>
            </div>
            <div
                class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                @click="getTickets(false,false, false, true, false, false, _.get(user, 'id', _.get(tenantAuthUser, 'id')), true)">
                <div class="fin-rounded-full fin-p-2 fin-bg-green-200">
                    <i class="fas fa-ticket-alt fa-lg fin-text-green-500"></i>
                </div>

                <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                    <span>My Recently updated tickets</span>
                    <span>{{ myUpdatedTotals }}</span>
                </div>
            </div>
            <div
                class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                @click="getTickets(false, false, false,false, true, false, _.get(user, 'id', _.get(tenantAuthUser, 'id')), true)">
                <div class="fin-rounded-full fin-p-2 fin-bg-orange-200">
                    <i class="fas fa-ticket-alt fa-lg fin-text-orange-500"></i>
                </div>

                <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                    <span>My Suspended tickets</span>
                    <span>{{ mySuspendedTotals }}</span>
                </div>
            </div>
            <div
                class="fin-flex fin-items-center fin-space-x-2 fin-bg-white fin-px-3 fin-py-3 fin-rounded fin-cursor-pointer fin-block fin-shadow fin-transition fin-transform fin-delay-150 fin-duration-300 fin-ease-in-out"
                @click="getTickets(false,false, false, false, false, true, _.get(user, 'id', _.get(tenantAuthUser, 'id')), true)">
                <div class="fin-rounded-full fin-p-2 fin-bg-red-200">
                    <i class="fas fa-ticket-alt fa-lg fin-text-red-500"></i>
                </div>

                <div class="fin-space-y-2 fin-flex fin-flex-col fin-capitalize fin-font-semibold">
                    <span>My Deleted tickets</span>
                    <span>{{ myDeletedTotals }}</span>
                </div>
            </div>
        </div>

        <div
            class="fin-bg-white fin-mb-2 fin-py-4 fin-px-2 fin-flex fin-items-center fin-space-x-4 fin-block fin-shadow">
            <el-select v-if="_.size(supportUserCategories) > 0" class="fin-w-56" v-model="supportUserCategoryFilter"
                       placeholder="Support User Category Filter"
                       clearable>
                <el-option v-for="(supportUserCategory, key) in supportUserCategories" :key="key"
                           :label="supportUserCategory.name"
                           :value="supportUserCategory.id"></el-option>
            </el-select>

            <!--Tenant Filter-->
            <el-select class="fin-w-80" v-model="filter.tenantFilter" placeholder="Tenant Filter"
                       collapse-tags
                       multiple
                       clearable>
                <el-option v-for="ticket in this.tenantsTeamsAndBrokers"
                           :key="ticket.id"
                           :label="ticket.name"
                           :value="ticket.id"></el-option>
            </el-select>

            <el-select class="fin-w-80" v-model="filter.categoryFilter" placeholder="Category Filter"
                       collapse-tags
                       multiple
                       clearable>
                <el-option v-for="(categoryOption, key) in mergedCategoryOptions()" :key="key"
                           :label="categoryOption"
                           :value="categoryOption"></el-option>
            </el-select>

            <el-select class="fin-w-56" v-model="filter.assigneFilter" placeholder="Assignee Filter" multiple clearable>
                <el-option v-for="(assignee, key) in assignees" :key="key"
                           :label="assignee.full_name"
                           :value="assignee.id"></el-option>
            </el-select>

            <el-input clearable class="fin-rounded fin-w-1/4" v-model="search" id="name"
                      placeholder="Search..."></el-input>

            <el-button v-if="!_.isEmpty(multipleSelection) && !this.deleted" @click="mergeTicket">
                Merge Tickets
            </el-button>
            <el-button type="danger" v-if="!_.isEmpty(multipleSelection) && !this.deleted" @click="deleteAll">
                Deleted All
            </el-button>
            <el-button type="Primary" v-if="!_.isEmpty(multipleSelection) && this.deleted" @click="reOpen">
                Re-Open
            </el-button>
            <el-button type="Primary" icon="el-icon-refresh"
                       @click="getTickets(unsolved, updated, suspended, deleted, userId)">
                Reload Tickets
            </el-button>
        </div>

        <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            class="fin-mt-4 fin-block fin-shadow"
            @row-click="(row, column, event) => viewTicketSameWindow(row)"
            :loading="loading"
            @selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column prop="category" label="Category"
                             sortable></el-table-column>
            <el-table-column :label="isTenant ? 'AppId' : 'AppId & Tenant'">
                <template slot-scope="scope">
                    <div v-if="!isTenant" class="fin-space-y-3 fin-flex fin-flex-col">
                        <a
                            :href="_.get(scope.row, 'application_id') ? '/admin/applications/' + _.get(scope.row, 'application_id') + '/stage/application' : ''"
                            :target="'_blank'"
                        >
                            {{ _.get(scope.row, 'application_id', '') }}
                        </a>
                        <span>
                            {{ _.get(_.find(tenantsTeamsAndBrokers, {id: scope.row.tenant}), 'name', '') }}
                        </span>
                    </div>

                    <div v-else class="fin-space-y-3 fin-flex fin-flex-col">
                        <span v-if="_.get(scope.row, 'application_id')">
                            {{ _.get(scope.row, 'application_id', '') }}
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="subject" label="Subject" sortable></el-table-column>
            <el-table-column prop="requester" label="Requester"
                             sortable></el-table-column>
            <el-table-column prop="assignee" label="Assignee"
                             sortable>
                <template slot-scope="scope">
                    {{ _.get(scope.row, 'assignee') }}
                </template>
            </el-table-column>
            <el-table-column prop="status" label="Status" sortable>
                <template slot-scope="scope">
                    <span
                        class="fin-capitalize fin-space-x-2"
                    >
                        {{ scope.row.status }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="priority" label="Priority" v-if="!isTenant" sortable>
                <template slot-scope="scope">
                    <span
                        class="fin-capitalize fin-space-x-2"
                        :class="priorityClass(scope.row.priority)"
                    >
                            <i class="fas fa-circle"></i>
                        {{ scope.row.priority }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="Requested" sortable>
                <template slot-scope="scope">
                    <span class="fin-capitalize">{{ formatDate(scope.row.created_at) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="Updated" sortable>
                <template slot-scope="scope">
                    <span class="fin-capitalize">{{ formatDate(scope.row.updated_at) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="Action">
                <template slot-scope="scope">
                    <div class="fin-flex fin-space-x-4">
                        <button v-if="_.get(scope.row, 'github_issue_url') && !isTenant"
                                class="btn amb-icon-btn" @click.stop="viewGithubIssue(scope.row)">
                            <i class="fa-brands fa-github"></i>
                        </button>

                        <el-popover
                            placement="top"
                            width="400"
                            trigger="hover">
                            <div class="fin-h-[calc(100vh-600px)] fin-overflow-auto">
                                <span v-html="_.get(scope.row.ticket_conversations, '0.conversation', '')"/>
                            </div>

                            <button slot="reference" class="btn amb-icon-btn" @click.stop="viewTicket(scope.row)"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </el-popover>

                        <button
                            v-if="!deleted"
                            class="btn amb-icon-btn"
                            @click.stop="deleteTicket(scope.row)"
                        >
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            class="fin-block fin-shadow fin-mt-2"
            v-show="_.get(collection, 'total') > 0"
            :total="_.get(collection, 'total')"
            :page.sync="_.get(collection, 'current_page')"
            :limit.sync="_.get(collection, 'per_page')"
            @pagination="getCollections"
        />

        <create-ticket
            :visible.sync="createVisible"
            :tenants-teams-brokers="tenantsTeamsAndBrokers"
            :priority-options="priorityOptions"
            :category-options="categoryOptions"
            :admin-category-options="adminCategoryOptions"
            :has-permissions="hasPermissions"
            :tenant="tenant"
            :auth-user="tenantAuthUser"
            :is-tenant="isTenant"
        ></create-ticket>

        <inbound-tickets
            :visible.sync="inboundTicketsVisible"
            :user="user"></inbound-tickets>

        <support-category-filter
            :visible.sync="supportCategoryVisible"
            :category-options="categoryOptions"
            :admin-category-options="adminCategoryOptions"
            :is-api="isApi"
        ></support-category-filter>

        <emails
            :visible.sync="emailsVisible"
            :is-api="isApi"
        />
    </div>
</template>

<script>

import Pagination from '@shared/components/pagination'
import CreateTicket from "./CreateTicket";
import InboundTickets from "./InboundTickets";
import SupportCategoryFilter from "./SupportCategoryFilter";
import Emails from "./Emails";
import moment from 'moment';

export default {
    name: 'TicketIndex',
    components: {
        CreateTicket,
        Pagination,
        InboundTickets,
        SupportCategoryFilter,
        Emails
    },
    props: {
        statusOptions: {
            required: false,
            type: [Array, Object]
        },
        priorityOptions: {
            required: true,
            type: [Array, Object]
        },
        categoryOptions: {
            required: true,
            type: [Array, Object]
        },
        adminCategoryOptions: {
            required: false,
            type: [Array, Object],
        },
        user: {
            required: false,
            type: [Object]
        },
        tenantAuthUser: {
            required: false,
            default: null,
            type: [Object]
        },
        tenant: {
            required: false,
            default: null,
        },
        isTenant: {
            required: false,
            default: null,
        },
        hasAdPermissions: {
            required: false,
            default: null,
        },
        hasPermissions: {
            required: false,
            default: false,
        },
        masterHasPermissions: {
            required: false,
            default: false,
        }
    },
    data() {
        return {
            supportStatisticsVisible: false,
            supportCategoryVisible: false,
            inboundTicketsVisible: false,
            createVisible: false,
            collection: [],
            unsolved: false,
            solved: false,
            closed: false,
            updated: false,
            suspended: false,
            deleted: false,
            event: null,
            userId: null,
            page: 1,
            loading: false,
            tenantsTeamsAndBrokers: null,
            allUnsolvedTotals: 0,
            allSolvedTotals: 0,
            allClosedTotals: 0,
            allSuspendedTotals: 0,
            allUpdatedTotals: 0,
            allDeletedTotals: 0,
            myUnsolvedTotals: 0,
            mySolvedTotals: 0,
            myClosedTotals: 0,
            mySuspendedTotals: 0,
            myUpdatedTotals: 0,
            myDeletedTotals: 0,
            multipleSelection: [],
            search: null,
            searchTimeout: null,
            searchTimeoutWait: 1000,
            multipleSelectionError: null,
            tenants: [],
            assignees: [],
            filter: {
                categoryFilter: [],
                assigneFilter: [],
                tenantFilter: [],
            },
            supportUserCategoryFilter: null,
            supportUserCategories: [],
            emailsVisible: false
        }
    },
    computed: {
        tableData() {
            return _.get(this.collection, 'data', [])
        },
        isApi() {
            return this.isTenant ? this.$tenant : this.$admin
        }
    },
    watch: {
        'search': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    if (this.isTenant && !this.hasPermissions) {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                    } else {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                    }
                }, this.searchTimeoutWait)
            },
            immediate: true,
            deep: true
        },
        'filter.categoryFilter': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    if (this.isTenant && !this.hasPermissions) {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                    } else {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                    }
                }, this.searchTimeoutWait)
            },
            immediate: true,
            deep: true
        },
        'filter.tenantFilter': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    if (this.isTenant && !this.hasPermissions) {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                    } else {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                    }
                }, this.searchTimeoutWait)
            },
            immediate: true,
            deep: true
        },
        'filter.assigneFilter': {
            handler(val) {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    if (this.isTenant && !this.hasPermissions) {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                    } else {
                        this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                    }
                }, this.searchTimeoutWait)
            },
            immediate: true,
            deep: true
        },
        'supportUserCategories': {
            handler(val) {
                if (_.size(val) && !_.isEmpty(this.user)) {
                    val.map((supportUserCategory) => {
                        if (_.includes(_.get(supportUserCategory, 'users'), _.get(this.user, 'id'))) {
                            this.filter.categoryFilter = _.get(supportUserCategory, 'category_filter')
                            this.supportUserCategoryFilter = _.get(supportUserCategory, 'id')
                        }
                    })
                }
            },
            immediate: true,
            deep: true
        },
        'supportUserCategoryFilter': {
            handler(val) {
                if (val === 'all') {
                    this.filter.categoryFilter = []
                } else if ((!_.isNull(val) || !_.isEmpty(val)) && !_.isEmpty(this.user)) {
                    const findSupportUserCategories = _.find(this.supportUserCategories, {id: val})

                    if (findSupportUserCategories) {
                        this.filter.categoryFilter = _.get(findSupportUserCategories, 'category_filter')
                    } else {
                        this.filter.categoryFilter = []
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        this.event = {
            page: this.page,
            limit: 10
        }

        this.getTenantTeamBrokers()

        this.getSupportUserCategories()

        this.$bus.$on('refresh-support-user-categories', () => {
            this.getSupportUserCategories()
        })

        if (this.isTenant && !this.hasPermissions) {
            this.getTickets(true, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
        } else {
            this.getTickets(true)
        }

        this.$bus.$on('reload-tickets', () => {
            if (this.isTenant && !this.hasPermissions) {
                this.getTickets(true, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
            } else {
                this.getTickets(true)
            }
        })

        this.getAssignees()
    },
    beforeDestroy() {
        this.$bus.$off('reload-tickets')
        this.$bus.$off('refresh-support-user-categories')
    },
    methods: {
        mergedCategoryOptions() {
            if (this.hasPermissions || this.masterHasPermissions) {
                return _.merge(this.categoryOptions, this.adminCategoryOptions)
            } else {
                return this.categoryOptions
            }
        },
        mergeTicket() {
            const mappedMultipleSelection = _.map(this.multipleSelection, 'tenant')

            if (!mappedMultipleSelection.every((val, i, arr) => val === arr[0])) {
                this.multipleSelectionError = 'You cannot merge tickets from different tenants '
            } else {
                this.isApi.post(`/api/tickets/merge-tickets`, {
                    multipleSelection: this.multipleSelection
                }).then((res) => {
                    this.$message({
                        message: "Successfully Merged Tickets",
                        type: "success"
                    });

                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                }).catch((error) => {
                    console.log('mergeTicket error ', error)

                    this.$message({
                        message: "Error Merging Tickets",
                        type: "error"
                    });
                })
            }
        },
        exportTicketStatistics(data) {
            let log_array_setup = [];
            let column_title = ['Broker', 'Requester', 'Category', 'Subject', 'Team', 'Tenant', 'Status', 'Requested', 'Updated'];
            let log_array = [];

            log_array.push(column_title.join(','));

            log_array_setup.push(_.map(data, 'assignee'));
            log_array_setup.push(_.map(data, 'requester'));
            log_array_setup.push(_.map(data, 'category'));
            log_array_setup.push(_.map(data, 'subject'));
            log_array_setup.push(_.map(data, 'team'));
            log_array_setup.push(_.map(data, 'tenant'));
            log_array_setup.push(_.map(data, 'status'));
            log_array_setup.push(_.map(data, 'created_at'));
            log_array_setup.push(_.map(data, 'updated_at'));

            for (let i = 0; i < data.length; i++) {
                let row = [];
                log_array_setup.forEach((column) => {
                    row.push(column[i]);
                });
                log_array.push(row.join(','));
            }


            let csvContent = log_array.join('\n');
            let fileURL = window.URL.createObjectURL(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }));
            let fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'application_audit_logs.csv');
            document.body.appendChild(fileLink);
            fileLink.click();
        },
        deleteAll() {
            this.isApi.post(`/api/tickets/delete-multiple-tickets`, {
                multipleSelection: this.multipleSelection
            }).then((res) => {
                this.$message({
                    message: "Successfully Deleted Tickets",
                    type: "success"
                });

                if (this.isTenant && !this.hasPermissions) {
                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                } else {
                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                }
            }).catch((error) => {
                console.log('mergeTicket error ', error)

                this.$message({
                    message: "Error Deleting Tickets",
                    type: "error"
                });
            })
        },
        reOpen() {
            this.isApi.post(`/api/tickets/re-open`, {
                multipleSelection: this.multipleSelection
            }).then((res) => {
                this.$message({
                    message: "Successfully Re-Opened Tickets",
                    type: "success"
                });

                if (this.isTenant && !this.hasPermissions) {
                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                } else {
                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                }
            }).catch((error) => {
                console.log('reOpen error ', error)

                this.$message({
                    message: "Error Re-Opening Tickets",
                    type: "error"
                });
            })
        },
        formatDate(date) {
            const utcDate = this.$moment.utc(date).tz(_.get(this.user, 'timezone', _.get(this.tenantAuthUser, 'timezone')));

            if (utcDate.isSame(this.$moment(), 'day')) {
                return utcDate.format("[Today] LT")
            } else if (utcDate.isBetween(this.$moment().startOf('week'), this.$moment().endOf('week'))) {
                return utcDate.format("ddd LT")
            } else if (utcDate.isBetween(this.$moment().startOf('year'), this.$moment().endOf('week'))) {
                return utcDate.format("MMM DD LT")
            } else {
                return utcDate.format("MMM DD YYYY LT")
            }
        },
        priorityClass(priority) {
            if (priority === 'low') {
                return 'fin-text-green-600 fin-font-semibold'
            } else if (priority === 'medium') {
                return 'fin-text-orange-600 fin-font-semibold'
            } else if (priority === 'high') {
                return 'fin-text-pink-600 fin-font-semibold'
            } else if (priority === 'critical') {
                return 'fin-text-red-600 fin-font-semibold'
            } else {
                ''
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        viewTicketSameWindow(row) {
            if (!this.isTenant) {
                window.location = `/admin/ticket/${_.get(row, 'id')}`
            }
        },
        viewGithubIssue(row) {
            window.open(`${_.get(row, 'github_issue_url')}`, '_blank')
        },
        viewTicket(row) {
            if (this.isTenant) {
                window.open(`/admin/tickets/${_.get(row, 'id')}`, '_blank')
            } else {
                window.open(`/admin/ticket/${_.get(row, 'id')}`, '_blank')
            }
        },
        deleteTicket(row) {
            this.isApi.delete(`/api/tickets/${row.id}`).then((res) => {
                this.$message({
                    message: "Ticket Deleted Successfully",
                    type: "success"
                });

                if (this.isTenant && !this.hasPermissions) {
                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, _.get(this.tenantAuthUser, 'id'))
                } else {
                    this.getTickets(this.unsolved, this.solved, this.closed, this.updated, this.suspended, this.deleted, this.userId)
                }
            }).catch((error) => {
                console.log('deleteTicket error ', error)
                this.$message({
                    message: "Error Deleting Ticket",
                    type: "error"
                });
            })
        },
        getTenantTeamBrokers() {
            this.isApi.get(`/api/tickets/tenant-team-brokers`).then((res) => {
                this.tenantsTeamsAndBrokers = res.data
            }).catch((error) => {
                console.log('getTenantTeamBrokers error ', error)
            })
        },
        getTickets(unsolved = false, solved = false, closed = false, updated = false, suspended = false, deleted = false, userId = null, categoryFilter = false) {
            if (categoryFilter) {
                this.filter.categoryFilter = []
            }

            this.unsolved = unsolved
            this.updated = updated
            this.solved = solved
            this.closed = closed
            this.suspended = suspended
            this.deleted = deleted
            this.userId = userId

            this.loading = true

            this.isApi.get(`/api/tickets`, {
                params: {
                    page: _.get(this.event, 'page', 1),
                    per_page: _.get(this.event, 'limit', 10),
                    unsolved: unsolved,
                    updated: updated,
                    solved: solved,
                    closed: closed,
                    suspended: suspended,
                    deleted: deleted,
                    userId: userId,
                    search: this.search,
                    authUserId: _.get(this.user, 'id', _.get(this.tenantAuthUser, 'id')),
                    tenant: this.tenant ? this.tenant : null,
                    filter: this.filter,
                    isTenant: this.isTenant
                }
            }).then((res) => {
                this.page = _.get(res.data, 'current_page')
                this.event.page = _.get(res.data, 'current_page')
                this.collection = res.data.tickets

                this.allUnsolvedTotals = res.data.allUnsolvedTotals
                this.allSolvedTotals = res.data.allSolvedTotals
                this.allClosedTotals = res.data.allClosedTotals
                this.allSuspendedTotals = res.data.allSuspendedTotals
                this.allUpdatedTotals = res.data.allUpdatedTotals
                this.allDeletedTotals = res.data.allDeletedTotals

                this.myUnsolvedTotals = res.data.myUnsolvedTotals
                this.mySolvedTotals = res.data.mySolvedTotals
                this.myClosedTotals = res.data.myClosedTotals
                this.mySuspendedTotals = res.data.mySuspendedTotals
                this.myUpdatedTotals = res.data.myUpdatedTotals
                this.myDeletedTotals = res.data.myDeletedTotals

                this.loading = false
            }).catch((error) => {
                console.log('error ', error)

                this.loading = false
            })
        },
        getCollections(event) {
            this.loading = true

            this.isApi.get(`/api/tickets`, {
                params: {
                    page: _.get(event, 'page', 1),
                    per_page: _.get(event, 'limit', 10),
                    unsolved: this.unsolved,
                    solved: this.solved,
                    closed: this.closed,
                    updated: this.updated,
                    suspended: this.suspended,
                    deleted: this.deleted,
                    userId: this.isTenant && !this.hasPermissions ? _.get(this.tenantAuthUser, 'id') : this.userId,
                    search: this.search,
                    authUserId: _.get(this.user, 'id', _.get(this.tenantAuthUser, 'id')),
                    tenant: this.isTenant && !this.hasPermissions ? this.tenant : null,
                    filter: this.filter,
                    isTenant: this.isTenant
                }
            }).then((res) => {
                this.page = _.get(res.data, 'current_page')
                this.event.page = _.get(res.data, 'current_page')
                this.collection = res.data.tickets

                this.allUnsolvedTotals = res.data.allUnsolvedTotals
                this.allSolvedTotals = res.data.allSolvedTotals
                this.allClosedTotals = res.data.allClosedTotals
                this.allSuspendedTotals = res.data.allSuspendedTotals
                this.allUpdatedTotals = res.data.allUpdatedTotals
                this.allDeletedTotals = res.data.allDeletedTotals

                this.myUnsolvedTotals = res.data.myUnsolvedTotals
                this.mySolvedTotals = res.data.mySolvedTotals
                this.myClosedTotals = res.data.myClosedTotals
                this.mySuspendedTotals = res.data.mySuspendedTotals
                this.myUpdatedTotals = res.data.myUpdatedTotals
                this.myDeletedTotals = res.data.myDeletedTotals

                this.loading = false
            }).catch((error) => {
                console.log('error ', error)

                this.loading = false
            })
        },
        getAssignees() {
            this.isApi.get(`/api/tickets/support-developer-brokers`).then((res) => {
                this.assignees = res.data
                console.log('assignees ', this.assignees)
            }).catch((error) => {
                console.log('getAssingees error ', error)
            })
        },
        getSupportUserCategories() {
            this.loading = true

            this.isApi
                .get(`/api/tickets/support-user-category`)
                .then((res) => {
                    const mergeSupportUserCategories = [...res.data, ...[{
                        id: 'all',
                        name: 'All'
                    }]]
                    this.supportUserCategories = mergeSupportUserCategories
                    this.loading = false
                })
                .catch((error) => {
                    console.log("getSupportUserCategories error ", error)
                    this.loading = false
                })
        },
    }
}
</script>
